import { useEffect, useRef } from 'react';
import { useBerichtenDrawerStore } from '../../stores/berichten-drawer-store';
import { OrderDetailView } from '../order-detail/OrderDetailView';
import { KlantDetailView } from '../klanten/KlantDetailView';

export function BerichtenDrawerPanel() {
  const openItem = useBerichtenDrawerStore((s) => s.openItem);
  const close = useBerichtenDrawerStore((s) => s.close);
  const containerRef = useRef<HTMLDivElement>(null);

  // Esc-to-close. Capture-phase so it runs before page-level Esc handlers.
  useEffect(() => {
    if (!openItem) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      close();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [openItem, close]);

  // Scroll drawer back to top on open-item change.
  useEffect(() => {
    if (!openItem) return;
    const scroller = containerRef.current?.querySelector('[data-drawer-scroll]') as HTMLElement | null;
    if (scroller) scroller.scrollTop = 0;
  }, [openItem?.type, openItem?.id]);

  if (!openItem) return null;

  return (
    <div
      ref={containerRef}
      className="flex-1 min-w-0 flex flex-col bg-white border-l border-slate-200 overflow-hidden"
      role="complementary"
      aria-label={openItem.type === 'order' ? 'Order detail' : 'Klant detail'}
    >
      {openItem.type === 'order' && (
        <OrderDetailView
          key={`order-${openItem.id}`}
          orderId={openItem.id}
          variant="drawer"
          onClose={close}
        />
      )}
      {openItem.type === 'klant' && (
        <KlantDetailView
          key={`klant-${openItem.id}`}
          customerId={openItem.id}
          type="account"
          variant="drawer"
          onClose={close}
        />
      )}
    </div>
  );
}
